import { EnvironmentConfigPort } from '../../ports'

export const environmentConfigAdapter: EnvironmentConfigPort = () => {
  const stage = window.location.hostname === 'www.otto.de' ? 'live' : 'nonlive'

  return {
    stage,
  }
}
